/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CompetitionModelListResult } from '../../models/competition-model-list-result';

export interface ApiCompetitionGet$JsonOdataMetadataFull$Params {
}

export function apiCompetitionGet$JsonOdataMetadataFull(http: HttpClient, rootUrl: string, params?: ApiCompetitionGet$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<CompetitionModelListResult>> {
  const rb = new RequestBuilder(rootUrl, apiCompetitionGet$JsonOdataMetadataFull.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json;odata.metadata=full', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CompetitionModelListResult>;
    })
  );
}

apiCompetitionGet$JsonOdataMetadataFull.PATH = '/api/competition';
